import React, { useState } from 'react';
import { ApprovalContentContainer } from '@/components/MobileApproval/ApprovalContents/styles';
import { Approval } from '@/types/api';
import NoData from '@/components/MobileApproval/NoData';
import Content from '@/components/MobileApproval/Content';
import { strDate, strStatus, tagToColor } from '@/utils/function';
import { t } from 'i18next';
import { Circle } from '@mui/icons-material';
import {
  StyledStatus,
  StyledStatusName,
} from '@/components/MobileApproval/ApprovalContent/styles';
import { getApprovalViewUrlByType } from '@/utils/urls';
import sendApprovalDocToApp from '@/utils/approval/sendApprovalDocToApp';
import ApprovalViewDialog from '@/components/MobileApproval/ApprovalViewDialog';

type P = {
  data?: Approval[];
  /** 모달 내 삭제·회수·결재·편집저장 후 목록 재검증 */
  onRefresh?: () => void;
};

const ApprovalContents = ({ data, onRefresh }: P) => {
  const [open, setOpen] = useState(false);
  const [docId, setDocId] = useState('');
  const [apvType, setApvType] = useState<number>();

  const sendPostMessage = (docId: string, typeCode: number) => {
    sendApprovalDocToApp(getApprovalViewUrlByType(docId, typeCode));
  };

  const handleClick = (docId: string, typeCode: number) => {
    if (window?.isRNWebview) {
      sendPostMessage(docId, typeCode);
    } else {
      setDocId(docId);
      setApvType(typeCode);
      setOpen(true);
    }
  };

  return (
    <ApprovalContentContainer>
      <ApprovalViewDialog
        open={open}
        docId={docId}
        apvType={apvType}
        onRefresh={onRefresh}
        onClose={() => setOpen(false)}
      />
      {data && data.length > 0 ? (
        data.map((res) => {
          const {
            commentCount,
            opinionCount,
            type,
            subject,
            author,
            authoredAt,
            createdAt,
            updatedAt,
            lastOpinionBy,
            latestComment,
            status,
            currentApprover,
          } = res;
          const totalCount = commentCount + opinionCount;
          const getLatestText = () => {
            if (!lastOpinionBy && !latestComment) return null;
            // 최신 것 결정
            const useComment =
              latestComment &&
              (!lastOpinionBy ||
                new Date(latestComment.updatedAt) >
                  new Date(lastOpinionBy.updatedAt));

            if (useComment) {
              const { name, positionName } = latestComment.createdBy.detail;

              return {
                author: `${name} ${positionName}`,
                comment: `${latestComment.content}`,
              };
            } else {
              return {
                author: `${lastOpinionBy?.name} ${lastOpinionBy?.positionName}`,
                comment: `${lastOpinionBy?.opinion}`,
              };
            }
          };

          const commentInfo = getLatestText();

          return (
            <Content
              key={res.docId}
              docId={res.docId}
              totalCount={totalCount}
              filterColor={tagToColor(type.tag)}
              filterName={type.name}
              subject={subject}
              rightTopContent={
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Circle
                    style={{
                      width: '6px',
                      height: '6px',
                      color: strStatus(t, status).color,
                    }}
                  />
                  <StyledStatus
                    style={{ color: strStatus(t, status).color }}
                  >{`${strStatus(t, status).title}`}</StyledStatus>
                  <StyledStatusName>
                    {currentApprover?.type === 2
                      ? '협조결재'
                      : currentApprover
                      ? currentApprover.name
                      : '-'}
                  </StyledStatusName>
                </div>
              }
              profiles={[author.profileImageUrl]}
              author={`${author.name} ${author.positionName}`}
              departmentName={`${author.placeName} ${author.departmentName}`}
              createAt={`${strDate(
                t,
                // 임시저장은 실제 수정일(updatedAt) 표시(만약 대비 createdAt 폴백).
                // 그 외 상태는 기존 표시 유지.
                status === 'S'
                  ? updatedAt ?? createdAt
                  : authoredAt ?? createdAt,
              )}${status === 'S' ? ' 수정' : ''}`}
              commentInfo={{
                author: commentInfo?.author,
                comment: commentInfo?.comment,
              }}
              handleClick={(clickedDocId) =>
                handleClick(clickedDocId, res.type.code)
              }
              isBookmarked={res.isBookmark}
            />
          );
        })
      ) : (
        <NoData />
      )}
    </ApprovalContentContainer>
  );
};

export default ApprovalContents;
